var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.split.js
// module id = 433
// module chunks = 0